module.exports = __webpack_public_path__ + "static_pc/img/10.72077814.png";